import angular from 'angular';
import cloneDeep from 'clone-deep';

/* @ngInject */
class Forms {
	constructor() {
		const defaultElementTypeValues = {
			label:        '',
			description:  '',
			value:        {},
			attributes:   {},
			layoutRow:    null,
			layoutColumn: null,
			required:     false,
		};

		this.elementTypeValues = {
			'input-captcha':            {
				...defaultElementTypeValues,
				label:    'Captcha Label',
				required: true,
			},
			'input-checkbox':           {
				...defaultElementTypeValues,
				label:      'Checkboxes Label',
				value:      {
					values: [],
				},
				attributes: {
					columns:      2,
					columnBreaks: 'md',
				},
			},
			'input-datetime':           {
				...defaultElementTypeValues,
				label: 'Date / Time Label',
			},
			'input-dropdown':           {
				...defaultElementTypeValues,
				label:      'Dropdown Label',
				value:      {
					values: [],
				},
				attributes: {
					multiple: false,
				},
			},
			'input-document-upload':    {
				...defaultElementTypeValues,
				label: 'File Upload Label',
				value: {
					value: null,
				},
			},
			'input-hidden':             {
				...defaultElementTypeValues,
				label: 'Key',
				value: {
					value: 'Value',
				},
			},
			'input-multiline':          {
				...defaultElementTypeValues,
				label:      'Multi Line Text Label',
				attributes: {
					rows: 3,
				},
			},
			'input-numerical':          {
				...defaultElementTypeValues,
				label:      'Number Label',
				attributes: {
					max:  100,
					min:  0,
					step: 1,
				},
			},
			'input-radio':              {
				...defaultElementTypeValues,
				label:      'Radio Buttons Label',
				value:      {
					values: [],
				},
				attributes: {
					columns:      2,
					columnBreaks: 'md',
				},
			},
			'input-text':               {
				...defaultElementTypeValues,
				label: 'Single Line Text Label',
			},
			'static-document-download': {
				...defaultElementTypeValues,
				label:    'Document Download Label',
				value:    {
					value: '',
				},
				required: false,
			},
			'static-document-preview':  {
				...defaultElementTypeValues,
				label:    'Document Preview Label',
				value:    {
					value: '',
				},
				required: false,
			},
			'static-text':              {
				...defaultElementTypeValues,
				value:      {
					value: 'Text',
				},
				attributes: {
					format: 'paragraph',
				},
				required:   false,
			},
		};

		const defaultElementTypeAttributes = {
			type:         {
				show: true,
			},
			label:        {
				show:     true,
				editable: true,
				required: true,
			},
			description:  {
				show:     true,
				editable: true,
				required: false,
			},
			value:        {
				show:     false,
				editable: false,
				required: false,
				type:     null,
			},
			attributes:   {
				show:     false,
				editable: false,
				required: false,
			},
			layoutRow:    {
				show:     true,
				editable: true,
				required: true,
			},
			layoutColumn: {
				show:     true,
				editable: true,
				required: true,
			},
			required:     {
				show:     true,
				editable: true,
			},
		};

		this.elementTypeAttributes = {
			'input-captcha':            {
				...defaultElementTypeAttributes,
				type:     {
					...defaultElementTypeAttributes.type,
					name: 'Captcha',
				},
				label:    {
					...defaultElementTypeAttributes.label,
					required: false,
				},
				required: {
					...defaultElementTypeAttributes.required,
					editable: false,
				},
			},
			'input-checkbox':           {
				...defaultElementTypeAttributes,
				type:       {
					...defaultElementTypeAttributes.type,
					name: 'Checkboxes',
				},
				value:      {
					...defaultElementTypeAttributes.value,
					show:     true,
					editable: true,
					type:     'selection',
					required: true,
				},
				attributes: {
					...defaultElementTypeAttributes.attributes,
					show:       true,
					editable:   true,
					attributes: [
						{
							label:   'Columns',
							model:   'columns',
							type:    'dropdown',
							options: [
								{
									label: '1',
									value: '1',
								},
								{
									label: '2',
									value: '2',
								},
								{
									label: '3',
									value: '3',
								},
								{
									label: '4',
									value: '4',
								},
								{
									label: '6',
									value: '6',
								},
							],
						},
						{
							label:   'Column Breaks',
							model:   'columnBreak',
							type:    'dropdown',
							options: [
								{
									label: 'Extra Small',
									value: 'xs',
								},
								{
									label: 'Small',
									value: 'sm',
								},
								{
									label: 'Medium',
									value: 'md',
								},
								{
									label: 'Large',
									value: 'lg',
								},
								{
									label: 'Extra Large',
									value: 'xl',
								},
							],
						},
					],
				},
			},
			'input-datetime':           {
				...defaultElementTypeAttributes,
				type: {
					...defaultElementTypeAttributes.type,
					name: 'Date / Time',
				},
			},
			'input-dropdown':           {
				...defaultElementTypeAttributes,
				type:       {
					...defaultElementTypeAttributes.type,
					name: 'Dropdown',
				},
				value:      {
					...defaultElementTypeAttributes.value,
					show:     true,
					editable: true,
					type:     'selection',
					required: true,
				},
				attributes: {
					...defaultElementTypeAttributes.attributes,
					show:       true,
					editable:   true,
					attributes: [
						{
							label:   'Responder Can Select Multiple Options',
							model:   'multiple',
							type:    'dropdown',
							options: [
								{
									label: 'Yes',
									value: true,
								},
								{
									label: 'No',
									value: false,
								},
							],
						},
					],
				},
			},
			'input-document-upload':    {
				...defaultElementTypeAttributes,
				type:  {
					...defaultElementTypeAttributes.type,
					name: 'Document Upload',
				},
				value: {
					...defaultElementTypeAttributes.value,
					show:     true,
					editable: true,
					type:     'upload',
					required: true,
				},
			},
			'input-hidden':             {
				...defaultElementTypeAttributes,
				type:        {
					...defaultElementTypeAttributes.type,
					name: 'Hidden',
				},
				description: {
					...defaultElementTypeAttributes.description,
					show:     false,
					editable: false,
				},
				value:       {
					...defaultElementTypeAttributes.value,
					show:     true,
					editable: true,
					type:     'text',
					required: true,
				},
				required:    {
					...defaultElementTypeAttributes.required,
					show:     false,
					editable: false,
				},
			},
			'input-multiline':          {
				...defaultElementTypeAttributes,
				type:       {
					...defaultElementTypeAttributes.type,
					name: 'Multi Line Text',
				},
				attributes: {
					...defaultElementTypeAttributes.attributes,
					show:       true,
					editable:   true,
					attributes: [
						{
							label: 'Rows',
							model: 'rows',
							type:  'number',
						},
					],
				},
			},
			'input-numerical':          {
				...defaultElementTypeAttributes,
				type:       {
					...defaultElementTypeAttributes.type,
					name: 'Number',
				},
				attributes: {
					...defaultElementTypeAttributes.attributes,
					show:       true,
					editable:   true,
					attributes: [
						{
							label: 'Minimum Value',
							model: 'min',
							type:  'number',
						},
						{
							label: 'Maximum Value',
							model: 'max',
							type:  'number',
						},
						{
							label: 'Step (Every 1, Every 5, etc.)',
							model: 'step',
							type:  'number',
						},
					],
				},
			},
			'input-radio':              {
				...defaultElementTypeAttributes,
				type:       {
					...defaultElementTypeAttributes.type,
					name: 'Radio Buttons',
				},
				value:      {
					...defaultElementTypeAttributes.value,
					show:     true,
					editable: true,
					type:     'selection',
					required: true,
				},
				attributes: {
					...defaultElementTypeAttributes.attributes,
					show:       true,
					editable:   true,
					attributes: [
						{
							label:   'Columns',
							model:   'columns',
							type:    'dropdown',
							options: [
								{
									label: '1',
									value: 1,
								},
								{
									label: '2',
									value: 2,
								},
								{
									label: '3',
									value: 3,
								},
								{
									label: '4',
									value: 4,
								},
								{
									label: '6',
									value: 6,
								},
							],
						},
						{
							label:   'Column Breaks',
							model:   'columnBreak',
							type:    'dropdown',
							options: [
								{
									label: 'Extra Small',
									value: 'xs',
								},
								{
									label: 'Small',
									value: 'sm',
								},
								{
									label: 'Medium',
									value: 'md',
								},
								{
									label: 'Large',
									value: 'lg',
								},
								{
									label: 'Extra Large',
									value: 'xl',
								},
							],
						},
					],
				},
			},
			'input-text':               {
				...defaultElementTypeAttributes,
				type: {
					...defaultElementTypeAttributes.type,
					name: 'Single Line Text',
				},
			},
			'static-document-download': {
				...defaultElementTypeAttributes,
				type:     {
					...defaultElementTypeAttributes.type,
					name: 'Document Download',
				},
				label:    {
					...defaultElementTypeAttributes.label,
					show:     true,
					editable: true,
					required: false,
				},
				value:    {
					...defaultElementTypeAttributes.value,
					show:     true,
					editable: true,
					type:     'download',
					required: true,
				},
				required: {
					...defaultElementTypeAttributes.required,
					show:     false,
					editable: false,
				},
			},
			'static-document-preview':  {
				...defaultElementTypeAttributes,
				type:     {
					...defaultElementTypeAttributes.type,
					name: 'Document Preview',
				},
				label:    {
					...defaultElementTypeAttributes.label,
					show:     true,
					editable: true,
					required: false,
				},
				value:    {
					...defaultElementTypeAttributes.value,
					show:     true,
					editable: true,
					type:     'download',
					required: true,
				},
				required: {
					...defaultElementTypeAttributes.required,
					show:     false,
					editable: false,
				},
			},
			'static-text':              {
				...defaultElementTypeAttributes,
				type:        {
					...defaultElementTypeAttributes.type,
					name: 'Text',
				},
				label:       {
					...defaultElementTypeAttributes.label,
					show:     false,
					editable: false,
					required: false,
				},
				description: {
					...defaultElementTypeAttributes.description,
					show:     false,
					editable: false,
				},
				value:       {
					...defaultElementTypeAttributes.value,
					show:     true,
					editable: true,
					type:     'textarea',
					required: true,
				},
				attributes:  {
					...defaultElementTypeAttributes.attributes,
					show:       true,
					editable:   true,
					attributes: [
						{
							label:   'Format',
							model:   'format',
							type:    'dropdown',
							options: [
								{
									label: 'Header',
									value: 'header',
								},
								{
									label: 'Subheader',
									value: 'subheader',
								},
								{
									label: 'Paragraph',
									value: 'paragraph',
								},
							],
						},
					],
				},
				required:    {
					...defaultElementTypeAttributes.required,
					show:     false,
					editable: false,
				},
			},
		};
	}

	getElementTypeAttributes() {
		return this.elementTypeAttributes;
	}

	getElementTypeValues(elementType) {
		return {
			type: elementType,
			...this.elementTypeValues[elementType],
		};
	}

	validate(version) {
		let errors = [];

		if (version.version.length === 0) {
			errors.push(`You must set the form version.`);
		}

		let layouts = [];

		angular.forEach(version.elements, (element, index) => {
			const label  = (element.label && element.label.length !== 0) ? (`"${element.label}"`) : (`${index + 1} (${this.elementTypeAttributes[element.type].type.name})`);
			const layout = `${element.layoutRow}-${element.layoutColumn}`;

			if (this.elementTypeAttributes[element.type].label.required && element.label.length === 0) {
				errors.push(`You must set a label for element ${label}.`);
			}

			if (this.elementTypeAttributes[element.type].description.required && element.description.length === 0) {
				errors.push(`You must set a description for element ${label}.`);
			}

			if (layouts.indexOf(layout) !== -1) {
				errors.push(`You must set a unique layout row and column combination for element ${label}.`);
			} else {
				layouts.push(layout);
			}

			switch (this.elementTypeAttributes[element.type].value.type) {
				case 'selection': {
					const values = element.value.values.map((value) => {
						return value.value;
					});

					if (this.elementTypeAttributes[element.type].value.required && values.length < 2) {
						errors.push(`You must have at least 2 values for element ${label}.`);
					}

					if (values.filter((value) => {
						return value === '';
					}).length > 0) {
						errors.push(`You must not have any empty values for element ${label}.`);
					}

					let uniqueValues = [
						...new Set(values),
					];

					if (values.length !== uniqueValues.length) {
						errors.push(`You must not have any duplicate values for element ${label}.`);
					}

					break;
				}

				case 'text':
				case 'textarea': {
					const value = element.value.value;

					if (this.elementTypeAttributes[element.type].value.required && (value === undefined || value === null || value.length === 0)) {
						errors.push(`You must set a valid value for element ${label}.`);
					}

					break;
				}

				case 'number': {
					const value = element.value.value;

					if (this.elementTypeAttributes[element.type].value.required && (value === undefined || value === null || value.length === 0)) {
						errors.push(`You must set a valid value for element ${label}.`);
					}

					break;
				}

				case 'download': {
					const value = element.value.value;

					if (this.elementTypeAttributes[element.type].value.required && (value === undefined || value === null || value.length === 0)) {
						errors.push(`You must set a valid value for element ${label}.`);
					}

					break;
				}

				case 'upload': {
					const value = element.value.value;

					if (this.elementTypeAttributes[element.type].value.required && (value === undefined || value === null || value.length === 0)) {
						errors.push(`You must set a valid value for element ${label}.`);
					}

					break;
				}

				// TODO: Datetime, others

				default: {
					break;
				}
			}
		});

		return errors;
	}

	getPostableVersion(input) {
		return {
			version:  input.version,
			elements: [
				...input.elements.map((element) => {
					let output = {
						...cloneDeep(element),
					};

					switch (this.elementTypeAttributes[element.type].value.type) {
						case 'selection': {
							output.value.values = element.value.values.map((value) => {
								return value.value;
							});

							break;
						}

						default: {
							break;
						}
					}

					return output;
				}),
			],
		};
	}
}

export default Forms;


// WEBPACK FOOTER //
// ./src/js/services/forms/index.js